let window_url = window.location.href
export const apiServerURL = (window_url.indexOf('mediamogul') != -1) ? 'http://tikapi.mediamogul.nl/' : 'http://local.kk-datavisuals-api:8888/'